module.exports = function getResource(label, vars = []) {
    const resources = {
        justArrived: 'Nouvel arrivage',
        bestsellers: 'Meilleurs vendeurs'
    };

    return resources[label];
};
